import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Document\DocumentPreviewDeleteController::__invoke
* @see app/Http/Controllers/Document/DocumentPreviewDeleteController.php
* @route '/api/editor/document/preview/delete/{type}/{document}/{file_id}'
*/
const DocumentPreviewDeleteController = (args: { type: string | number, document: string | number, file_id: string | number } | [type: string | number, document: string | number, file_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DocumentPreviewDeleteController.url(args, options),
    method: 'delete',
})

DocumentPreviewDeleteController.definition = {
    methods: ["delete"],
    url: '/api/editor/document/preview/delete/{type}/{document}/{file_id}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Document\DocumentPreviewDeleteController::__invoke
* @see app/Http/Controllers/Document/DocumentPreviewDeleteController.php
* @route '/api/editor/document/preview/delete/{type}/{document}/{file_id}'
*/
DocumentPreviewDeleteController.url = (args: { type: string | number, document: string | number, file_id: string | number } | [type: string | number, document: string | number, file_id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            type: args[0],
            document: args[1],
            file_id: args[2],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        type: args.type,
        document: args.document,
        file_id: args.file_id,
    }

    return DocumentPreviewDeleteController.definition.url
            .replace('{type}', parsedArgs.type.toString())
            .replace('{document}', parsedArgs.document.toString())
            .replace('{file_id}', parsedArgs.file_id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Document\DocumentPreviewDeleteController::__invoke
* @see app/Http/Controllers/Document/DocumentPreviewDeleteController.php
* @route '/api/editor/document/preview/delete/{type}/{document}/{file_id}'
*/
DocumentPreviewDeleteController.delete = (args: { type: string | number, document: string | number, file_id: string | number } | [type: string | number, document: string | number, file_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DocumentPreviewDeleteController.url(args, options),
    method: 'delete',
})

export default DocumentPreviewDeleteController